/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AnalyticsSignalScope,
  AnalyticsSignalScope$Outbound,
  AnalyticsSignalScope$outboundSchema,
} from "./analyticssignalscope.js";

export type DimensionValuesRequestBody = {
  /**
   * With dimension=attribute, the exact signal attribute key. dimension=attribute_keys discovers keys.
   */
  attribute?: string | undefined;
  /**
   * Dataset to look in
   */
  dataset: string;
  /**
   * Dimension to list values of
   */
  dimension: string;
  /**
   * Start of the half-open window [from, to), ISO 8601
   */
  from: Date;
  /**
   * Maximum values. Defaults to 50, at most 200.
   */
  limit?: number | undefined;
  signalScope?: AnalyticsSignalScope | undefined;
  /**
   * End of the half-open window [from, to), ISO 8601
   */
  to: Date;
};

/** @internal */
export type DimensionValuesRequestBody$Outbound = {
  attribute?: string | undefined;
  dataset: string;
  dimension: string;
  from: string;
  limit: number;
  signal_scope?: AnalyticsSignalScope$Outbound | undefined;
  to: string;
};

/** @internal */
export const DimensionValuesRequestBody$outboundSchema: z.ZodMiniType<
  DimensionValuesRequestBody$Outbound,
  DimensionValuesRequestBody
> = z.pipe(
  z.object({
    attribute: z.optional(z.string()),
    dataset: z.string(),
    dimension: z.string(),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    limit: z._default(z.int(), 50),
    signalScope: z.optional(AnalyticsSignalScope$outboundSchema),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      signalScope: "signal_scope",
    });
  }),
);

export function dimensionValuesRequestBodyToJSON(
  dimensionValuesRequestBody: DimensionValuesRequestBody,
): string {
  return JSON.stringify(
    DimensionValuesRequestBody$outboundSchema.parse(dimensionValuesRequestBody),
  );
}
